import { analytics } from 'lib/analytics';
import { analyticsEvents } from 'lib/analytics/analytics.constants';
import type {
  AnalyticsEventName,
  AnalyticsSendEventProps
} from 'lib/analytics/analytics.types';
import { brazeService } from 'lib/engagement/braze';

const BRAZE_ALLOWED_EVENTS = new Set<AnalyticsEventName>([
  analyticsEvents.ads_clicked,
  analyticsEvents.ads_viewed,
  analyticsEvents.collection_event_clicked,
  analyticsEvents.collection_filter_applied,
  analyticsEvents.collection_viewed,
  analyticsEvents.event_add_calendar_clicked,
  analyticsEvents.event_share_clicked,
  analyticsEvents.home_highlight_events_clicked,
  analyticsEvents.home_viewed,
  analyticsEvents.order_purchase_callback,
  analyticsEvents.rail_event_clicked,
  analyticsEvents.rail_view_more_clicked,
  analyticsEvents.search_recommended_clicked,
  analyticsEvents.search_recommended_event_clicked,
  analyticsEvents.search_result_clicked,
  analyticsEvents.search_results_viewed,
  analyticsEvents.search_started,
  analyticsEvents.search_submitted
]);

export function sendTrackingEvent(
  name: AnalyticsEventName,
  props?: AnalyticsSendEventProps
): boolean {
  const sendTracking = analytics.sendEvent(name, props);

  if (BRAZE_ALLOWED_EVENTS.has(name)) {
    const brazeProps = props
      ? (({ transport, ...rest }) => rest)(props as Record<string, unknown>)
      : undefined;
    void brazeService.logCustomEvent(name, brazeProps).catch(() => undefined);
  }

  return sendTracking;
}
